const _temp0 = require("./Cosmo_2.webp");
const _temp1 = require("./Cosmo_3.webp");
const _temp2 = require("./main.webp");
module.exports = {
  "Cosmo_2": _temp0,
  "Cosmo_3": _temp1,
  "main": _temp2
}